import React, { useState, useEffect } from "react";
import { DataGrid } from '@mui/x-data-grid'
import { useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons"; // import edit e trash icon
import DeleteConfirmation from "./../../components/DeleteConfirmation.js";
import { useAxiosPrivate } from "./../../hooks/useAxiosPrivate.js";
import "./../../App.css";
import localeToPortuguese from "./../../components/funcoes_gerais.js";
import { useHeader } from './../../components/HeaderContext';
import OkModal from "./../../components/OkModal.js";
import { encryptId } from './../../components/utils_react.jsx'
import useAuth from "./../../hooks/useAuth.js";

// React Notification
import { NotificationManager } from 'react-notifications';

const Users = () => {

    const navigate = useNavigate();

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const axiosPrivate = useAxiosPrivate();

    const { auth } = useAuth();


    const ReturnPage = "/users";

    const [loading, setLoading] = useState(false);

    // texto do cabeçalho da pagina
    const { setHeader } = useHeader();
    useEffect(() => {
        setHeader("Users");
    }, [setHeader]);


    const [showOkModal, setShowOkModal] = useState(false);
    const [okMessage, setOkMessage] = useState("");
    const [typeOkModal, setTypeOkModal] = useState("success");

    const [type, setType] = useState(null);
    const [id, setId] = useState(null);         // usado no dialogo de confirmar delete e voltar
    const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false);
    const [deleteMessage, setDeleteMessage] = useState(null);

    // Handle the displaying of the modal based on type and id
    const showDeleteModal = (type, id) => {
        setId(id);
        console.log(id);
        setDeleteMessage(`Are you sure you want to delete the record: ${type}?`);

        setDisplayConfirmationModal(true);
    };

    // Hide the modal
    const hideConfirmationModal = () => {
        setDisplayConfirmationModal(false);
    };

    const handleShowOkModal = (message, type) => {
        setOkMessage(message);
        setTypeOkModal(type);
        setShowOkModal(true);
    }

    const handleHideOkModal = () => {
        setShowOkModal(false);
    };


    const columns = [
        {
            field: 'actions',
            headerName: '',
            disableColumnMenu: true,
            width: 60,
            renderCell: (params) => (
                <div>
                    <FontAwesomeIcon icon={faEdit} style={{ cursor: 'pointer', marginRight: '9px' }} onClick={() => EditRow(params.row.id)} />
                    <FontAwesomeIcon icon={faTrash} style={{ cursor: 'pointer' }} onClick={() => deleteRow(params.row.username, params.row.id)} />
                </div>
            ),
        },
        { field: 'user_id', headerName: 'ID', width: 70, disableColumnMenu: true },
        { field: 'username', headerName: 'Username', width: 100, disableColumnMenu: true },
        { field: 'full_name', headerName: 'Full Name', width: 200, disableColumnMenu: true },
        { field: 'group_id', headerName: 'group_id', width: 160, disableColumnMenu: true },
        { field: 'group_name', headerName: 'Group Name', width: 160, disableColumnMenu: true },
        { field: 'user_type', headerName: 'User Type', width: 160, disableColumnMenu: true },
        { field: 'supplier_id', headerName: 'Supplier', width: 160, disableColumnMenu: true },
        { field: 'supplier_code', headerName: 'Supplier Code', width: 160, disableColumnMenu: true },
        { field: 'supplier_name', headerName: 'Supplier Name', width: 260, disableColumnMenu: true }
    ]

    function EditRow(param1) {
        console.log("EditRow: ", param1);

        const encryptedId = encryptId(param1);
        navigate(`/users_edit/${encryptedId}`);
    }

    function deleteRow(param1, param2) {
        console.log("deleteRow: ", param1, " ", param2);

        if (param1 === 'admin') {
            handleShowOkModal("Cannot delete admin user!", "warning")
            return; // Stop submission if any field is invalid
        }

        showDeleteModal(param1, param2)
        navigate(ReturnPage);
    }

    const [rows, setRows] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [limit, setPageSize] = useState(20);
    const [page, setPage] = useState(0);
    const [sortField, setSortField] = useState("username");
    const [sortOrder, setSortOrder] = useState("asc");

    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 20, });

    useEffect(() => {
        fetchUsers();
    }, [page, limit, sortField, sortOrder]);


    const fetchUsers = async () => {
        try {

            setLoading(true);

            await axiosPrivate.get(`${baseURL}/users_page?page=${page + 1}&limit=${limit}&sortfield=${sortField}&sortorder=${sortOrder}`)

                .then(result => {
                    console.log(result.data.result);

                    // return ok
                    if (result.status === 200) {
                        setRows(result.data.result.map(row => ({ id: row.user_id, ...row })));
                        //setRows(result.data.rows);
                        setTotalRows(result.data.total_count);

                        setLoading(false);
                    }
                    else {
                        alert(result.data.Error);
                    }
                }).catch(err => console.log(err))
        } catch (error) {
            console.error('Failed to fetch products:', error);
            setLoading(false);
        }
    };


    const handleSubmitDelete = async (id) => {
        console.log(id);
        try {
            await axiosPrivate.delete(`${baseURL}/users/` + id)
                .then(res => {
                    NotificationManager.success('Record deleted!', 'Sucesso!', 2000);
                    console.log(res)
                    fetchUsers();
                })
                .catch(err => console.log(err))
            setDisplayConfirmationModal(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };



    function handlePageChange(newPage, newPageSize) {
        console.log("handlePageChange: ", newPage, " ", newPageSize, " atual limite: ", limit);

        if (newPageSize === limit) {
            setPage(newPage);
            setPaginationModel({ ...paginationModel, page: newPage, pageSize: limit });
            console.log("paginationModel: ", paginationModel);
        }
        else {
            setPage(0);
            setPageSize(newPageSize);
            console.log("mudou page size: ", paginationModel);
            setPaginationModel({ ...paginationModel, page: 0, pageSize: newPageSize });
        }
    }


    // Handler for sorting
    //const handleSortModelChange = (newSortModel) => {
    function handleSortModelChange(newSortModel) {
        const { field, sort } = newSortModel[0] || {};
        console.log("SortModel:", field, " ", sort);

        if (field) {
            setPage(0);
            setSortField(field);
            setSortOrder(sort);
            console.log("Field Page:", page);
        }
        else {
            setSortField("username");
            setSortOrder("asc");
        }

        setPaginationModel({ ...paginationModel, page: 0 });

    };

    const handleBtnNovo = async () => {
        console.log("handleBtnNovo");
        navigate(`/users_add`);
        //await fetchStockSeleccionado();
    };



    return (
        <div className="mt-2">

            <div className="row w-100 mb-2">

                <div className="col-1 d-flex flex-column justify-content-end">
                    <div className="mt-auto">
                        <button type="button" className="btn btn-outline-success btn-sm mb-2" id="abrir" onClick={handleBtnNovo}>+ New</button>
                    </div>
                </div>
            </div>


            <div style={{ width: '90%', position: 'relative' }}>
                <DataGrid

                    slotProps={{
                        pagination: {
                            showFirstButton: true,
                            showLastButton: true,
                        },
                    }}

                    page={page - 1}
                    rows={rows}
                    columns={columns}
                    rowHeight={40}
                    disableRowSelectionOnClick={true}
                    autoHeight={true}
                    paginationMode="server"
                    sortingMode="server"
                    density="compact"
                    rowCount={totalRows}
                    pagination

                    pageSizeOptions={[20, 40, 60]}

                    onCellClick={(params) => {
                        console.log("===cell click===", params);
                    }}

                    onPaginationModelChange={(params) => {
                        console.log("===page size===", params);
                        //console.log(params.page);
                        handlePageChange(params.page, params.pageSize);
                    }}

                    paginationModel={paginationModel}

                    initialState={{
                        pagination: { paginationModel: { page: 0, pageSize: 20 } },
                        // Hide column servico_id, the other columns will remain visible
                        columns: { columnVisibilityModel: { user_id: false, supplier_id: false, group_id: false } },
                    }}

                    onSortModelChange={handleSortModelChange}

                />
                <DeleteConfirmation showModal={displayConfirmationModal}
                    confirmModal={() => handleSubmitDelete(id)}
                    hideModal={hideConfirmationModal} type={type} id={id} message={deleteMessage} />

                <OkModal
                    showModal={showOkModal}
                    hideModal={handleHideOkModal}
                    message={okMessage}
                    type={typeOkModal}
                    header=""
                />

                {loading && (
                    <div className="overlay">
                        <div className="loading-circle"></div>
                    </div>
                )}


            </div>
        </div>
    );
}

export default Users

